// OpenAI Ads pixel helpers. The loader + init live in _app.js.
// Docs: https://developers.openai.com/ads/measurement-pixel

export const oaiqMeasure = (eventName, eventData) => {
  if (typeof window === 'undefined' || typeof window.oaiq !== 'function') {
    return;
  }
  window.oaiq('measure', eventName, eventData);
};

// `id` is the app slug (alfy, billy, ...), `name` its display name.
export const oaiqCheckoutStarted = ({ id, name }) => {
  oaiqMeasure('checkout_started', {
    type: 'contents',
    contents: [{ id, name, content_type: 'product' }],
  });
};
